import { render, staticRenderFns } from "./RateBar.vue?vue&type=template&id=23e1d832&"
import script from "./RateBar.vue?vue&type=script&lang=js&"
export * from "./RateBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports